import ApiService from '../../../../shared/services/api-service';
import commonActions from '../../../../shared/store/common/action-creators';
import phonesActionsCreators from '../../phones/action-creators';
import myProfileActionCreators from './my-profile';
import notificationsActionsCreator from '../../notifications/action-creators';

const myProfilePhonesActionsCreators = {
  updateMyProfilePhones(formData) {
    const patchData = {
      data: formData.phones,
      patched: 'phones',
    };
    return async (dispatch) => {
      dispatch(this.setIsLoading('updateMyProfilePhones'));
      const data = await ApiService.patch('/api/v1/my-profile', patchData)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('updateMyProfilePhones'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.updateMyProfilePhonesSuccess(data));
      }
    };
  },
  updateMyProfilePhonesSuccess(updated) {
    return (dispatch) => {
      dispatch(myProfileActionCreators.replaceMyProfile(updated.data));
      // This action handles success for both add and edit, so make sure we dispatch
      //   to reset both related state keys
      dispatch(phonesActionsCreators.resetPhoneState());
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Phones updated'))
    };
  },
};

export default myProfilePhonesActionsCreators;
